<script>
    import Image from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Image.svelte?1733898724663';
    import { url_join } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url.js?1733898724663';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724663';
    import { strip_tags } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/sanitize.js?1733898724663';
    import { get_src } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/get_src.js?1733898724663';

    export let products = [];
    export let store;

    const slug = "p";

    $: swatches = products ?? [];
</script>

<section class="swatches">
    {#each swatches as product}
        {@const src = get_src(product)}
        {@const href = url_join(
            store,
            slug,
            get_attribute_value(product, 'url_key')
        )}
        {@const name = strip_tags(get_attribute_value(product, 'name'))}
        <a {href} class="swatch-item" title={name}>
            <Image
                {src}
                alt={name}
                width={40}
                height={40}
                mode={'contain'}
                lazy={false}
            />
        </a>
    {/each}
</section>


<style>
    .swatches {
        display: flex;
        justify-content: center;
        gap: 0.25rem;
        flex-wrap: wrap;
        width: 100%;
        bottom: 0;
        padding: 10px 0 0 0;
    }

    .swatches > .swatch-item :global(img) {
        width: 40px !important;
        height: 40px !important;
        padding: 5px;
        background: var(--white);
        border: 1px solid var(--brown);
    }
</style>